export function useHasCamera() {
  return false;
}
